import type { TableColumnType, TableProps } from 'antd';

import type { BoDich } from '../../../../i18n';
import { soNguyen } from '../../chung/nghiep-vu/so-thong-ke';
import type { SoFox } from '../../chung/nghiep-vu/types-vet';

/** Ô số của bảng: căn phải do cột lo, mỗi ô đúng một số. `null` hiện "—" (dòng ghi trước khi có token Fox). */
export const LOP_O_SO = 'whitespace-nowrap font-mono text-xs tabular-nums';

const RONG_O_FOX = 84;

/** Nhóm cột "Token Fox" (đầu vào, đầu ra, tổng) — đơn vị khách thấy, dùng chung cho mọi bảng của nhật ký (ADR-0123 mục 5). */
export function cotFox<T extends SoFox>(t: BoDich['t'], locale: string): NonNullable<TableProps<T>['columns']>[number] {
  const o = (key: string, title: string, doc: (r: T) => number | null, lop: string): TableColumnType<T> => ({
    title,
    key,
    width: RONG_O_FOX,
    align: 'right',
    render: (_v, r) => <span className={`${LOP_O_SO} ${lop}`}>{soNguyen(doc(r), locale)}</span>,
  });
  return {
    title: t('nktvSuDungAi.cotFox'),
    align: 'center',
    children: [
      o('fox-vao', t('nktvSuDungAi.foxVao'), (r) => r.fox_dau_vao, 'text-content-secondary'),
      o('fox-ra', t('nktvSuDungAi.foxRa'), (r) => r.fox_dau_ra, 'text-content-secondary'),
      o('fox-tong', t('nktvSuDungAi.foxTong'), (r) => r.fox_tokens, 'font-medium text-content-primary'),
    ],
  };
}

/** Cột token thật — chỉ cổng nền tảng. */
export function cotTokenThat<T extends { tong_token?: number | null }>(t: BoDich['t'], locale: string): TableColumnType<T> {
  return {
    title: t('nktvSuDungAi.cotTokenThat'),
    key: 'token-that',
    width: 104,
    align: 'right',
    render: (_v, r) => <span className={`${LOP_O_SO} text-content-secondary`}>{soNguyen(r.tong_token, locale)}</span>,
  };
}
